"use client";

import { motion } from "framer-motion";
import { Heading, Text } from "@/components/ui/typography";
import React from "react";

// SET_HEIGHT = 7 cards × 137px step = 959px
// SET 1 tops: -63, 74, 211, 348, 485, 622, 759
// SET 2 tops: each + 959 → 896, 1033, 1170, 1307, 1444, 1581, 1718
const SET1 = [
  { label: "Certificate of Incorporation",        pos: "top-[-63px] right-[60px]" },
  { label: "Business Registration Certificate",   pos: "top-[74px]  right-[100px]" },
  { label: "Articles of Association",             pos: "top-[211px] right-[140px]" },
  { label: "Passport Verification",               pos: "top-[348px] right-[180px]" },
  { label: "Business Activity Explanation",       pos: "top-[485px] right-[140px]" },
  { label: "Website or Store Link",               pos: "top-[622px] right-[100px]" },
  { label: "Expected Transaction Profile",        pos: "top-[759px] right-[60px]" },
];

const SET2 = [
  { label: "Certificate of Incorporation",        pos: "top-[896px]  right-[40px]" },
  { label: "Business Registration Certificate",   pos: "top-[1033px]  right-[100px]" },
  { label: "Articles of Association",             pos: "top-[1170px] right-[140px]" },
  { label: "Passport Verification",               pos: "top-[1307px] right-[180px]" },
  { label: "Business Activity Explanation",       pos: "top-[1444px] right-[140px]" },
  { label: "Website or Store Link",               pos: "top-[1581px]  right-[100px]" },
  { label: "Expected Transaction Profile",        pos: "top-[1718px] right-[40px]" },
];

export default function RemoteHKSection({ heading = "Remote HK Company Bank Account Application" }: { heading?: string } = {}) {
  return (
    <section className="relative bg-black overflow-hidden max-w-[1220px] mx-auto min-[1150px]:h-[700px] h-auto flex items-center min-[1240px]:px-0 px-4">
      {/* LEFT TEXT */}
      <div className="w-full max-w-[584px] space-y-6">
        <Heading as="h2" variant="section">
          {heading}
        </Heading>
        <Text variant="muted" className="font-medium">
          Typical requirements for your HK business account application. MuteTaxes
          prepares these in approval-ready format before submission.
        </Text>
      </div>

      {/* MARQUEE LAYER */}
      <div className=" overflow-hidden w-full pointer-events-none min-[1150px]:block hidden">
        {/* h-[2118px] = 959 × 2 + 200; animates by -959px for a seamless loop */}
        <motion.div
          className="absolute top-0 left-0 w-full h-[2118px]"
          animate={{ y: [0, -959] }}
          transition={{ duration: 14, ease: "linear", repeat: Infinity }}
        >
          {SET1.map((card) => (
            <Card key={`a-${card.label}`} pos={card.pos}>
              {card.label}
            </Card>
          ))}
          {SET2.map((card) => (
            <Card key={`b-${card.label}`} pos={card.pos}>
              {card.label}
            </Card>
          ))}
        </motion.div>

        {/* FADE TOP */}
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-black to-transparent z-10" />
        {/* FADE BOTTOM */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent z-10" />
      </div>
    </section>
  );
}

function Card({
  children,
  pos,
}: {
  children: React.ReactNode;
  pos: string;
}) {
  return (
    <div
      className={`absolute flex items-center gap-6 w-[440px] px-10 py-6 rounded-2xl bg-[#0f1218] border border-white/10 ${pos}`}
    >
      <div className="w-[56px] h-[56px] flex-shrink-0 bg-white/10 rounded-lg" />
      <p className="text-white font-semibold text-[20px] leading-[120%]">
        {children}
      </p>
    </div>
  );
}
